export function narrowDown() {

    /*----------------------------------
    絞り込み関連js start
    ----------------------------------*/


    var searchBox = '.searchBox'; // 絞り込む項目を選択するエリア
    var listItem = '.searchItem';   // 絞り込み対象のアイテム
    var hideClass = 'is-hide';     // 絞り込み対象外の場合に付与されるclass名
    var searchBtn = '#searchBtn'; // 検索ボタン

    //検索（絞り込み）トリガー
    $(function() {
        // チェック（絞り込み）項目を変更した時
        //$(document).on('change', searchBox + ' input', function() {
            //search_filter();
        //});

        //検索ボタンをクリックした時
        $(searchBtn).on('click', function() {
            search_filter();

            $('html, body').animate({
                scrollTop: $("#result").offset().top
            }, 500); // 1000ミリ秒 (1秒) でスクロール
        });
    });

    /**
     * リストの絞り込みを行う
     */
    function search_filter() {
        // 非表示状態を解除
        $(listItem).removeClass(hideClass);
        var hideCount = 0;
        for (var i = 0; i < $(searchBox).length; i++) {
            var name = $(searchBox).eq(i).find('input').attr('name');
            // 選択されている項目を取得
            var searchData = get_selected_input_items(name);
            // 選択されている項目がない、またはALLを選択している場合は飛ばす
            if(searchData.length === 0 || searchData[0] === '') {
                continue;
            }
            // リスト内の各アイテムをチェック
            for (var j = 0; j < $(listItem).length; j++) {
                // アイテムに設定している項目を取得
                var itemData = get_setting_values_in_item($(listItem).eq(j), name);
                // 絞り込み対象かどうかを調べる
                var check = array_match_check(itemData, searchData);
                if(!check) {
                    $(listItem).eq(j).addClass(hideClass);
                    hideCount++;
                }
            }
        }
        if ($(".p-indexList_resultItem").length === $(".p-indexList_resultItem.is-hide").length) {
            $('.no-result-message').text('該当する病院がありませんでした。');
        } else {
            $('.no-result-message').text('');
        }
    }



    /**
     * inputで選択されている値の一覧を取得する
     * @param  {String} name 対象にするinputのname属性の値
     * @return {Array}       選択されているinputのvalue属性の値
     */
    function get_selected_input_items(name) {
        var searchData = [];
        $('[name=' + name + ']:checked').each(function() {
            searchData.push($(this).val());
        });
        return searchData;
    }
    /**
     * リスト内のアイテムに設定している値の一覧を取得する
     * @param  {Object} target 対象にするアイテムのjQueryオブジェクト
     * @param  {String} data   対象にするアイテムのdata属性の名前
     * @return {Array}         対象にするアイテムのdata属性の値
     */
    function get_setting_values_in_item(target, data) {
    var itemData = target.data(data);
    if(!Array.isArray(itemData)) {
        itemData = [itemData];
    }
    return itemData;
    }

    /**
     * 2つの配列内で一致する文字列があるかどうかを調べる
     * @param  {Array} arr1 調べる配列1
     * @param  {Array} arr2 調べる配列2
     * @return {Boolean}    一致する値があるかどうか
     */
    function array_match_check(arr1, arr2) {
    // 絞り込み対象かどうかを調べる
    var arrCheck = false;
    for (var i = 0; i < arr1.length; i++) {
        if(arr2.indexOf(arr1[i]) >= 0) {
        arrCheck = true;
        break;
        }
    }
    return arrCheck;
    }

    // エリア検索 チェックボックス制御
    $(function(){
    $('#checkAll_area').prop('checked', true);
    $('#search_area .searchBox_item_each input[type="checkbox"]').change(function(){
        var cnt1 = $('#search_area .searchBox_item_each input[type="checkbox"]:checked').length;
            if(cnt1 == 0) {
            $('#checkAll_area').prop('checked',true);
            } else {
            $('#checkAll_area').prop('checked',false);
            }
        });
    $('#checkAll_area').change(function() {
        if ($('#checkAll_area').prop('checked')) {
        $('#search_area .searchBox_item_each input[type="checkbox"]').prop('checked', false);
        } else {
        $('#search_area .searchBox_item_All input[type="checkbox"]').prop('checked', true);
        }
    });
    });
    // 機能検索 チェックボックス制御
    $(function(){
    $('#checkAll_function').prop('checked', true);
    $('#search_function .searchBox_item_each input[type="checkbox"]').change(function(){
        var cnt1 = $('#search_function .searchBox_item_each input[type="checkbox"]:checked').length;
            if(cnt1 == 0) {
            $('#checkAll_function').prop('checked',true);
            } else {
            $('#checkAll_function').prop('checked',false);
            }
        });
    $('#checkAll_function').change(function() {
        if ($('#checkAll_function').prop('checked')) {
        $('#search_function .searchBox_item_each input[type="checkbox"]').prop('checked', false);
        } else {
        $('#search_function .searchBox_item_All input[type="checkbox"]').prop('checked', true);
        }
    });
    });


    /*----------------------------------
    絞り込み関連js end
    ----------------------------------*/


    //data-functionから、各機能に「active」クラス付与
    $(function(){
        $(".searchItem").each(function() {
            const arr = $(this).data('function');
            if(arr.some(value => value === "高度急性期")){
            $(this).find(".function > li:nth-child(1)").addClass("active");
            }
            if(arr.some(value => value === "急性期")){
            $(this).find(".function > li:nth-child(2)").addClass("active");
            }
            if(arr.some(value => value === "回復期")){
            $(this).find(".function > li:nth-child(3)").addClass("active");
            }
            if(arr.some(value => value === "慢性期")){
            $(this).find(".function > li:nth-child(4)").addClass("active");
            }
            if(arr.some(value => value === "緩和ケア")){
            $(this).find(".function > li:nth-child(5)").addClass("active");
            }
            if(arr.some(value => value === "地域包括ケア")){
            $(this).find(".function > li:nth-child(6)").addClass("active");
            }
            if(arr.some(value => value === "訪問看護ステーション")){
            $(this).find(".function > li:nth-child(7)").addClass("active");
            }
            if(arr.some(value => value === "医療型障害児入所施設")){
            $(this).find(".function > li:nth-child(8)").addClass("active");
            }
        });
    });

    //要素をランダムに並び替える。
    const items = document.querySelectorAll('.p-indexList_resultItem');
    if(items){
        items.forEach(item => {
            // 各要素にランダムなorder値を設定
            item.style.order = Math.floor(Math.random() * items.length);
        });
    }
}